module.exports = __webpack_public_path__ + "static/media/The-Enclave-Responsibility-Matrix.22c24f03.pdf";